module.exports = __webpack_public_path__ + "static/media/not_found.2161ce16.jpg";